import { useEffect } from 'react';

/** Controls the head meta theme-color element. This is used to change the colour of the area behind
 * the notch on an iPhone.
 */
export function useMetaThemeColor(
  /**  */
  cssColorString: string,
) {
  useEffect(() => {
    let oldValue: string | undefined;
    let elem = document.head.querySelector('meta[name="theme-color"]');
    if (!elem) {
      oldValue = undefined;
      elem = document.createElement('meta');
      document.head.appendChild(elem);
      elem.setAttribute('name', 'theme-color');
    } else {
      oldValue = elem.getAttribute('content') || undefined;
    }
    elem.setAttribute('content', cssColorString);

    return () => {
      if (oldValue) {
        elem.setAttribute('content', oldValue);
      } else {
        document.head.removeChild(elem);
      }
    };
  }, []);
}
